// extracted by mini-css-extract-plugin
export default {"section":"reportsSummary_section__69W2J","listRow":"reportsSummary_listRow__MS+nj"};